import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import { sedesPorInstitucionId } from "../../../../Services/Rest";

function CreaInfraestructuraMetros(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);

  // Estados formulario
  const [postSede, setPostSede] = useState("");
  const [postMetrosFisicos, setPostMetrosFisicos] = useState("");
  const [postMetrosConstruidos, setPostMetrosConstruidos] = useState("");
  const [postMetrosSalaEspera, setPostMetrosSalaEspera] = useState("");
  const [postMetrosUrgencias, setPostMetrosUrgencias] = useState("");
  const [postMetrosRadiologia, setPostMetrosRadiologia] = useState("");
  const [postMetrosCirugia, setPostMetrosCirugia] = useState("");
  const [postMetrosPartos, setPostMetrosPartos] = useState("");

  // 🔹 Cargar sedes
  useEffect(() => {
    axios({
      method: "get",
      url: sedesPorInstitucionId + cookies.get("institucionid"),
    })
      .then((res) => setList(res.data || []))
      .catch((error) => console.log(error));
  }, []);

  // 🔹 Crear registro
  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaInfraestructuraMetros",
      data: {
        sede: postSede,
        metros_fisicos: postMetrosFisicos,
        metros_Construidos: postMetrosConstruidos,
        metros_Sala_Espera: postMetrosSalaEspera,
        metros_Urgencias: postMetrosUrgencias,
        metros_Radiologia: postMetrosRadiologia,
        metros_Cirugia: postMetrosCirugia,
        metros_Partos: postMetrosPartos,
        solicitudId: props.idSolicitud,
      },
    })
      .then(() => {
        alert("Registro creado con éxito");

        // 🔁 Refrescar tabla en el padre
        props.onCreate();

        // Cerrar modal
        setIsOpen(false);

        // Limpiar formulario
        setPostSede("");
        setPostMetrosFisicos("");
        setPostMetrosConstruidos("");
        setPostMetrosSalaEspera("");
        setPostMetrosUrgencias("");
        setPostMetrosRadiologia("");
        setPostMetrosCirugia("");
        setPostMetrosPartos("");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear registro");
      });
  };

  return (
    <>
      <button className="btn btn-primary mb-3" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow">
            <div className="card-header">
              <h5 className="m-0 font-weight-bold text-primary">
                Crear Infraestructura (Metros)
              </h5>
            </div>

            <div className="card-body">
              <form onSubmit={postData}>
                {/* SEDE */}
                <div className="form-group">
                  <label>Sede</label>
                  <select
                    className="form-control"
                    value={postSede}
                    onChange={(e) => setPostSede(e.target.value)}
                    required
                  >
                    <option value="">Seleccione la sede</option>
                    {list.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                    <option value="0">No tiene</option>
                  </select>
                </div>

                {/* METROS FÍSICOS / CONSTRUIDOS */}
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Metros físicos</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosFisicos}
                      onChange={(e) => setPostMetrosFisicos(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Metros construidos</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosConstruidos}
                      onChange={(e) => setPostMetrosConstruidos(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* SALA ESPERA / URGENCIAS */}
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Metros sala de espera</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosSalaEspera}
                      onChange={(e) => setPostMetrosSalaEspera(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Metros urgencias</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosUrgencias}
                      onChange={(e) => setPostMetrosUrgencias(e.target.value)}
                    />
                  </div>
                </div>

                {/* RADIOLOGÍA / CIRUGÍA */}
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Metros radiología</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosRadiologia}
                      onChange={(e) => setPostMetrosRadiologia(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Metros cirugía</label>
                    <input
                      type="number"
                      className="form-control"
                      value={postMetrosCirugia}
                      onChange={(e) => setPostMetrosCirugia(e.target.value)}
                    />
                  </div>
                </div>

                {/* PARTOS */}
                <div className="form-group">
                  <label>Metros partos</label>
                  <input
                    type="number"
                    className="form-control"
                    value={postMetrosPartos}
                    onChange={(e) => setPostMetrosPartos(e.target.value)}
                  />
                </div>

                {/* BOTONES */}
                <div className="text-right mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    onClick={() => setIsOpen(false)}
                  >
                    Cancelar
                  </button>

                  <button type="submit" className="btn btn-primary">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaInfraestructuraMetros;
